import { render, staticRenderFns } from "./SamOneColumnImage.vue?vue&type=template&id=6427e16a&scoped=true&"
import script from "./SamOneColumnImage.vue?vue&type=script&lang=js&"
export * from "./SamOneColumnImage.vue?vue&type=script&lang=js&"
import style0 from "./SamOneColumnImage.vue?vue&type=style&index=0&id=6427e16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427e16a",
  null
  
)

export default component.exports